export const SAVED = 1;
export const WORKING = 2;
export const LEAVED = 3;